// Imports nothing, so callers that only need the type string do not load every plugin the agent uses.
/** The agent type of the orchestrator, stored in its session context. */
export const ORCHESTRATOR_AGENT_TYPE = "orchestrator";
